<template>
  <static-template>
    <h1>Advise</h1>
  </static-template>
</template>

<script>
export default {
  name: 'AdvisePage',
};
</script>
